import { Injectable, inject } from '@angular/core';
import { StorageV2Service, StoreV2Map } from '@schenck/rotec-components';
import { RotorSearchResult } from './rotor-search.service';

@Injectable()
export class RotorSelectInfoService extends StoreV2Map<RotorSearchResult> {
  constructor() {
    const storageService = inject(StorageV2Service);

    super('RotorSelectInfoService', { name: 'RotorSelectInfoService', storageService });
  }

  /**
   * Adds a new rotor to the memory
   */
  addRotor(rotor: RotorSearchResult) {
    const rotors = this.state;
    rotors[rotor.id] = rotor;
    this.patchState('add rotor', rotors);
  }

  /**
   * Removes a rotor from the comparison.
   */
  removeRotor(id: string) {
    delete this.state[id];
    this.patchState('remove rotor', { ...this.state });
  }

  /**
   * Removes all rotors.
   */
  clearAll() {
    this.patchState('clear all', {});
  }
}
